export type Provider = {
  specialtySourceValue: string;
  specialtySourceLabel: string;
};
export type Procedure = { sourceValue: string; sourceLabel: string };

export default class ConsultationAllowedType {
  constructor(
    public id: string,
    public enabled: boolean,
    public provider: Provider,
    public procedure: Procedure
  ) {}
}
